import { FormControl } from '@mui/material';
import { getRatesOptions } from '@utriper/core';
import { SelectComponent } from '@utriper/core-ui';
import { useCurrencies } from 'core/contexts/currency';
import { useTranslation } from 'react-i18next';

const MoneyDropDown = ({collapsed = false}) => {
    const { t: translate } = useTranslation();

    const { currency, setCurrency } = useCurrencies();

    const options = getRatesOptions().map((rate) => ({
        value: rate.name,
        name: rate.name,
        id: rate.name,
    }));


    return (
        <>
            <FormControl fullWidth>
                {!collapsed ? (
                <SelectComponent
                    values={options}
                    value={currency}
                    onChange={(e) => {
                        setCurrency(e.value);
                        window.localStorage.setItem('currency', e.value);
                    }}
                    label={translate('layout.appBar.currency')}
                />
                ):
                (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    {currency}</div>
                )
                }
            </FormControl>
        </>
    );
};


export default MoneyDropDown;
